<template>
  <div>
    <base-header class="pb-6 bg-light">
      <b-row align-v="center" class="py-4">
        <b-col cols="12" lg="6">
          <h6 class="h2 d-inline-block mb-0 text-dark">Tower Management</h6>
        </b-col>
        <b-col cols="12" lg="6" class="text-right">
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
      </b-row>
      <!-- Card stats -->
      <b-row>
        <b-col xl="12">
          <b-card no-body>
            <b-card-body>
              <b-tabs content-class="mt-3">
                <b-tab title="Low Tower Information">
                  <div class="w-100 text-right">
                    <b-button  size="sm" variant="success" v-on:click="addNewTopOffPlanOpen">Add Tower Data</b-button>
                  </div>
                  <div class="mt-4">
                    <div class="text-center w-100">
                      <b-icon icon="three-dots"
                              class="text-center" animation="cylon"
                              font-scale="4"
                              v-if="loadingStatus"></b-icon>
                    </div>
                    <div class="mb-3" v-if="!loadingStatus">
                      <b-row>
                        <b-col cols="7" xl="8" lg="7" md="7" sm="6">

                          <b-form-group
                            label=""
                            label-for="per-page-select"
                            label-cols-sm="0"
                            label-cols-md="0"
                            label-cols-lg="0"
                            label-align-sm="center"
                            class="mb-2 per-page-select"
                          >
                            <label for="per-page-select" class="mr-2 text-sm mt-1">Show</label>
                            <b-form-select
                              id="per-page-select"
                              class="diameter-report-select"
                              v-model="perPage"
                              :options="pageOptions"
                              size="sm"
                              v-on:input="changePageOption(perPage)"
                            ></b-form-select>
                            <label for="per-page-select" class="ml-2 text-sm mt-1">entries</label>
                          </b-form-group>

                        </b-col>

                        <b-col cols="5" xl="4" lg="5" md="5" sm="6" class="customer-table-select">
                          <b-form-group
                            label=""
                            label-for="filter-input"
                            label-align-sm="right"
                            class="mb-0 per-page-select"
                          >
                            <b-input-group size="sm">
                              <b-form-input
                                id="filter-input"
                                v-model="filter"
                                placeholder="Search..."
                                size="sm"
                                class="mb-4"
                              ></b-form-input>

                            </b-input-group>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-table
                        striped hover
                        :items="tableData"
                        :fields="tableColumns"
                        :filter="filter"
                        :filter-included-fields="filterOn"
                        :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc"
                        :sort-direction="sortDirection"
                        table-class="text-nowrap"
                        class="primary-table"
                        sticky-header="true"
                        show-empty
                        responsive
                        small
                        @sort-changed="headerColumnChanged"
                        @filtered="onFiltered"
                      >
                        <template #cell(action)="row">
                          <span>
                            <i class="fas fa-pen-nib mr-3 cursor-pointer text-success" v-b-modal.tower-management
                              v-on:click="editTopOffPlanInfo(row.item.id)"></i>
                            <i class="fas fa-trash-alt cursor-pointer  text-danger"
                              v-on:click="deleteTopOffPlanInfo(row.item.id)"></i>
                          </span>
                        </template>
                      </b-table>
                      <b-row class="mt-4">
                        <b-col>
                          <p class="ml-3 nowrap">{{ startPage() }} - {{ lastPage() }} of {{ totalRows }}</p>
                        </b-col>
                        <b-col >
                          <b-pagination
                            class="flex-fill-custom pr-4 ml-3 justify-content-end"
                            v-model="currentPage"
                            :total-rows="totalRows"
                            :per-page="perPage"
                            size="sm"
                          ></b-pagination>
                        </b-col>
                      </b-row>
                    </div>
                  </div>
                </b-tab>
              </b-tabs>

              <b-modal centered size="lg" id="tower-management" hide-footer title="Tower Management" class="tower-management"
                       cancel-title="Close" ok-variant="primary" ok-title="Submit">
                <AddTowerInformation></AddTowerInformation>
              </b-modal>

            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </base-header>
    <b-container fluid class="mt--6">

    </b-container>
  </div>
</template>

<script>
  import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb'
  import moment from "moment";
  import administratorService from "../../../../common/api-services/administrator-service";
  import swal from "sweetalert2";
  import AddTowerInformation from "../../../Components/Add-Tower-Information";
  import pagination from '../../../../common/format/pagination'

  export default {
    name: "Tower-Management",
    components: {
      AddTowerInformation,
      RouteBreadCrumb
    },
    data() {
      return {
        loadingStatus: true,
        totalRows: 0,
        currentPage: 1,
        perPage: 10,
        pageOptions: [10, 25, 50, 100],
        tableColumns: [
          {key: 'id', label: 'ID', sortable: true, sortDirection: 'desc'},
          {key: 'rat', label: 'RAT', sortable: true, sortDirection: 'desc'},
          {key: 'mcc', label: 'MCC', sortable: true, sortDirection: 'desc'},
          {key: 'mnc', label: 'MNC', sortable: true, sortDirection: 'desc'},
          {key: 'area', label: 'Area', sortable: true, sortDirection: 'desc'},
          {key: 'cell', label: 'Cell', sortable: true, sortDirection: 'desc'},
          {key: 'lat', label: 'Latitude', sortable: true, sortDirection: 'desc'},
          {key: 'lon', label: 'Longitude', sortable: true, sortDirection: 'desc'},
          {key: 'action', label: '', sortable: true, sortDirection: 'desc'},
        ],
        tableData: [],
        sortBy: '',
        sortDesc: false,
        sortDirection: 'asc',
        filter: null,
        filterOn: [],
        loadingNum: 1,
        paginationLoadingBar: true,
        topOffPlanTitle: ''
      }
    },
    mounted() {
      this.$root.$on('addTowerInformation', (() => {
        this.getTopOffPlansFunc();
      }))

      this.getTotalRows();
      this.getTopOffPlansFunc();
    },
    methods: {
      getTotalRows() {
        if (this.perPage > this.totalRows) {
          this.fromPage = this.totalRows;
        } else {
          this.fromPage = this.perPage;
        }
      },
      startPage() {
        return pagination.startPageFunc(this.currentPage, this.perPage)
      }, 
      lastPage() {
        return pagination.lastPageFunc(this.currentPage, this.perPage, this.totalRows)
      },

      headerColumnChanged(e) {
        this.sortBy = e.sortBy;
        if (e.sortDesc === true) {
          this.sortDirection = 'asc';
        } else {
          this.sortDirection = 'desc'
        }
        this.getTopOffPlansFunc();
      },

      getTopOffPlansFunc() {
        this.loadingStatus = true;
        administratorService.getTowerList().then(res => {
          this.loadingStatus = false;
          if (res && !res.includes('NULL') && !res.includes('FAIL')) {
            this.tableData = res;
            this.totalRows = this.tableData.length;
            this.getTotalRows();
          }
        })
      },

      addNewTopOffPlanOpen() {
        this.$bvModal.show('tower-management');
      },

      changePageOption(page) {
        this.getTotalRows()
      },

      editTopOffPlanInfo(id) {
        this.tableData.map(item => {
          if (item.id === id) {
            let data = {item: item, status: true}
            setTimeout(() => {
              this.$root.$emit('editTowerInformation', data)
            }, 400)
          }
        })
      },

      deleteTopOffPlanInfo(id) {
        swal.fire({
          title: `Tower Information`,
          text: `Delete selected Tower?`,
          buttonsStyling: false,
          showCloseButton: true,
          showCancelButton: true,

          confirmButtonText: 'Delete',
          cancelButtonText: 'Cancel',
          //cancelButtonClass: 'btn btn-danger',
        }).then((result) => {
          if (result.isConfirmed) {
            administratorService.deleteTower(id).then(res => {
              let type = ''
              if (res.Error) {
                type = 'error';
                res = res.Error
              } else {
                type = 'success'
              }
              this.$toast(res, {type: type})
              this.getTopOffPlansFunc();
            })
          }
        });
      },

      onFiltered(filteredItems) {
        this.totalRows = filteredItems.length
        this.currentPage = 1
      },
    },
  }
</script>

